import { BootstrapGridBreakpoints } from '@gn-audio/ui/constants/bootstrap-grid-breakpoints';
export var defaultSlickResponsive = [
    { breakpoint: BootstrapGridBreakpoints.Small, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: BootstrapGridBreakpoints.Medium, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: BootstrapGridBreakpoints.Large, settings: { slidesToShow: 3, slidesToScroll: 3 } },
];
